import { Button, Modal } from "react-bootstrap";
import { t } from 'i18next';
import { title } from "process";

export default function DeleteModal(props:{
    showModal: boolean,
    setShowModal: Function,
    title: string,
    deleteFunction: Function
}){
    
    return(
        <Modal show={props?.showModal} onHide={() => props?.setShowModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>{props?.title}</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <div>{t("text.sure_delete")}</div>
            </Modal.Body>
    
            <Modal.Footer>
                <Button
                    variant="secondary"
                    className="text-uppercase"
                    style={{ borderRadius: 25 }}
                    onClick={() => props?.setShowModal(false)}
                >
                    {t('button.cancel')}
                </Button>
    
                <Button
                    variant="danger"
                    className="text-uppercase bg-danger"
                    style={{ color: "white", borderRadius: 25 }}
                    onClick={(e)=>props?.deleteFunction(e)}
                >
                    {t('title.delete')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}